module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('hero'), _vm._v(" "), _c('media'), _vm._v(" "), (_vm.web3 === undefined) ? _c('downloadWallet') : _vm._e(), _vm._v(" "), _c('saleSummary'), _vm._v(" "), _c('tokenSummary'), _vm._v(" "), _c('docs'), _vm._v(" "), _c('core'), _vm._v(" "), _c('posts'), _vm._v(" "), _c('team')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-37ed25c8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 508
// module chunks = 1